import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const Loading = ({ className }) => {
  const intl = useIntl();
  return (
    <div className="loader-wrapper">
      <div className={`loader ${className}`}>
        {intl.formatMessage({
          defaultMessage: 'Loading...',
        })}
      </div>
    </div>
  );
};

Loading.propTypes = {
  className: PropTypes.string,
};

Loading.defaultProps = {
  className: '', // predefined classes: gray
};

export default Loading;
